import { render, staticRenderFns } from "./AnalysesPage.vue?vue&type=template&id=049d4a3c&"
import script from "./AnalysesPage.vue?vue&type=script&lang=js&"
export * from "./AnalysesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports